import cart from './cart'
export default `mutation setShippingMethodsOnCart($input: SetShippingMethodsOnCartInput) {
  setShippingMethodsOnCart(input: $input) {
    cart { ${cart} }
   }
 }
`
